import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

const variantLabel = ({ existing }) =>
  [
    existing.productName || existing.productCode,
    existing.colourDescription,
    existing.sizeDescription,
    existing.fitDescription,
  ]
    .filter(Boolean)
    .join(" - ");

/**
 * Asks whether quantities for variants already in the basket should be added
 * to the existing quantity or replace it.
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {Array<{saveLine: Object, existing: Object}>} props.conflicts
 * @param {(choice: "add"|"replace") => void} props.onChoose
 * @param {() => void} props.onCancel
 */
export const BasketQuantityDialog = ({
  open,
  conflicts,
  onChoose,
  onCancel,
}) => {
  const single = conflicts.length === 1;
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onCancel}
      aria-labelledby="basket-quantity-dialog-title"
    >
      <DialogTitle id="basket-quantity-dialog-title">
        {single ? "Item already in basket" : "Items already in basket"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {single
            ? "This item is already in the basket. Do you want to add to the existing quantity or replace it?"
            : "These items are already in the basket. Do you want to add to the existing quantities or replace them?"}
        </DialogContentText>
        <List dense>
          {conflicts.map((conflict) => {
            const existingQty = Number(conflict.existing.quantity);
            const newQty = Number(conflict.saveLine.quantity);
            return (
              <ListItem key={conflict.existing.lineNo} disableGutters>
                <ListItemText
                  primary={variantLabel(conflict)}
                  secondary={`In basket: ${existingQty} · Entered: ${newQty} · Add = ${existingQty + newQty} · Replace = ${newQty}`}
                />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="outlined" onClick={() => onChoose("replace")}>
          Replace
        </Button>
        <Button variant="contained" onClick={() => onChoose("add")}>
          Add to basket
        </Button>
      </DialogActions>
    </Dialog>
  );
};
